import React from 'react';
import { useNumberInput } from '@chakra-ui/react';

import { QuantityInput } from '../../../../../../common/components/QuantityInput/QuantityInput';
import { LanguagesConfig } from '../../../../../../contexts/LocalizationContext/types';

type CategoryQuantityUnknownItemProps = {
  category: { id: string; translations: LanguagesConfig };
  onUpdateItemsQuantity: (categoryId: string, quantity: number, userId: string) => void;
  categoryQuantity: number;
  userId: string;
  maxValue: number;
};

export const CategoryQuantityUnknownItem = ({
  category,
  onUpdateItemsQuantity,
  categoryQuantity,
  userId,
  maxValue,
}: CategoryQuantityUnknownItemProps) => {
  const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } = useNumberInput({
    step: 1,
    defaultValue: 0,
    min: 0,
    max: maxValue,
    onChange: (valueAsString, valueAsNumber) => {
      const updatedValue = valueAsNumber > maxValue ? maxValue : valueAsNumber;
      onUpdateItemsQuantity(category.id, updatedValue, userId);
    },
    value: categoryQuantity,
  });
  return (
    <QuantityInput
      inputProps={{ ...getInputProps() }}
      decrementButtonProps={{ ...getDecrementButtonProps() }}
      incrementButtonProps={{ ...getIncrementButtonProps() }}
    />
  );
};
